import { useState } from "react";
import { IoMdClose } from "react-icons/io";
import { useDispatch } from "react-redux";
import { setAppError } from "../../../../store/userSlice";
import nodeinstance from "../../../../nodeInstance";

export default function Vendor_PopUp({
  popUp,
  setPopUp,
  propData,
  setTrigger,
  trigger,
}) {
  console.log(".....propData....", propData);

  const [amountPaid, setAmountPaid] = useState("");
  const handleInputFieldChange = (e) => {
    setAmountPaid(e.target.value);
  };
  const [invoiceNumber, setInvoiceNumber] = useState("");

  const handleInvoiceChange = (e) => {
    setInvoiceNumber(e.target.value);
  };
  const dispatch = useDispatch();

  const token = localStorage.getItem("nodeToken");

  const updatedAPI = async () => {
    if (amountPaid === "" || invoiceNumber === "") {
      dispatch(
        setAppError({
          msg: "All fields are require",
        })
      );
      return;
    }
    const reqObject = {
      amount_paid: amountPaid,
      invoice_no: invoiceNumber,
      Insurance_Flow_Type: "APPLY INSURANCE",
    };
    try {
      console.log(
        "Data to be printed here....",
        amountPaid,
        invoiceNumber,
        propData
      );
      const response = await nodeinstance.put(
        `/insurance-dependent/updateAmountByFinance/${propData.Master_id}`,
        reqObject,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      if (response.status === 200) {
        setTrigger(!trigger);
        setPopUp(false);
      }
    } catch (error) {
      console.log("error to be seen here....", error);
      dispatch(
        setAppError({
          msg: "Error while updating data",
          //   color: "success",
        })
      );
    }
  };
  return (
    <>
      <div
        className={`fixed z-50 top-0 left-0 min-w-full min-h-screen bg-black/50 justify-center items-center ${
          popUp ? "flex" : "hidden"
        }`}
      >
        {/* <div className="max-w-lg w-full h-auto   rounded-md bg-white/95 flex  flex-col p-4 relative"> */}
        <div className="max-w-lg w-full overflow-auto rounded-md bg-white/95 flex flex-col p-4 relative">
          <div className="flex justify-between items-center w-full">
            <h1
              className="text-md font-semibold cursor-pointer"
              onClick={() => {
                setPopUp(false);
              }}
            >
              <IoMdClose />
            </h1>
          </div>
          <div className="flex flex-col p-2 gap-1 w-full max-w-md">
            <label htmlFor={`addOrEdit-name`} className="text-xs ">
              AMOUNT PAID
            </label>
            <input
              type="number"
              className="border-[1px] border-border dark:bg-dark rounded-md p-1 py-2 text-xs"
              name="remarks_for_invoice_cancellation"
              onChange={(e) => {
                handleInputFieldChange(e);
              }}
              required
            />
          </div>
          <div className="flex flex-col p-2 gap-1 w-full max-w-md">
            <label htmlFor={`addOrEdit-name`} className="text-xs ">
              INVOICE NUMBER
            </label>
            <input
              type="text"
              className="border-[1px] border-border dark:bg-dark rounded-md p-1 py-2 text-xs"
              name="remarks_for_invoice_cancellation"
              onChange={(e) => {
                handleInvoiceChange(e);
              }}
              required
            />
          </div>
          <div className="flex gap-3 w-full justify-center" style={{ m: 2 }}>
            <button
              className="p-2 bg-red text-white rounded-md w-full max-w-sm m-2 my-4 flex gap-3 justify-center items-center"
              onClick={() => {
                updatedAPI();
              }}
            >
              {" "}
              <p>SUBMIT</p>
            </button>
          </div>
        </div>
      </div>
    </>
  );
}
